import Overview from './overview.vue';
import FullIndex from '@rebuild/materials/shared/custom/FullIndex.vue';
import MobOverview from '@rebuild/materials/shared/custom/MobOverview.vue';
import MobFull from '@rebuild/materials/shared/custom/MobFull.vue';

export const componentMap = {
	overview: Overview,
	full: FullIndex,
	'mob-overview': MobOverview,
	'mob-full': MobFull
}; 